import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { SelectField } from 'shared/controls/select-field';
import { useCustomerShipTo } from 'shared/queries';
import { Brands } from 'shared/types';
export function CustomerShipToDropdown() {
  const { brand } = useParams<{ brand: Brands }>();
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const customerId = watch('customer.customerNumber');
  const isNew = watch('customer.isNew');
  const { addresses, isLoading } = useCustomerShipTo(brand, !isNew ? customerId : '');
  return (
    <SelectField
      name='customer.customerShipTo'
      label='Customer Ship To'
      error={Boolean(errors?.customer?.customerShipTo)}
      helperText={errors?.customer?.customerShipTo?.message}
      options={addresses || []}
      loading={isLoading}
      disabled={isNew}
      getOptionLabel={shipTo => {
        const address = shipTo.shipToAddressLine1
          ? `${shipTo.shipToAddressLine1} ${shipTo.shipToAddressLine2}`
          : shipTo.shipToAddressLine2;

        return shipTo ? `${shipTo.transactionCount} - ${shipTo.shipToId} - ${address}` : '';
      }}
      getOptionSelected={(option, value) => {
        if (!option || !value) return true;
        return option.uniqueId === value.uniqueId;
      }}
    />
  );
}
